import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Building2, ExternalLink } from "lucide-react";

const PLACEHOLDER = [
  { id: "o1", name: "Kane County Film Commission", type: "Film Commission", region: "Kanab" },
  { id: "o2", name: "Utah Film Commission", type: "State Agency", region: "Statewide" },
  { id: "o3", name: "Southern Utah Cinema Guild", type: "Guild", region: "Southern Utah" },
  { id: "o4", name: "Dixie State — Film & TV Program", type: "Education", region: "St. George" },
  { id: "o5", name: "Moab-Monument Valley Film Commission", type: "Film Commission", region: "Moab" },
  { id: "o6", name: "Utah Media Arts Alliance", type: "Nonprofit", region: "Statewide" },
];

export default function Orgs() {
  const [orgs, setOrgs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const data = await api.orgs();
        if (alive) setOrgs(Array.isArray(data) && data.length ? data : PLACEHOLDER);
      } catch { if (alive) setOrgs(PLACEHOLDER); }
      finally { if (alive) setLoading(false); }
    })();
    return () => { alive = false; };
  }, []);

  return (
    <div>
      <div className="mb-8">
        <div className="text-xs uppercase tracking-[0.3em] text-neutral-400 mb-3">Partner Organizations</div>
        <h1 className="font-display text-4xl sm:text-5xl tracking-tighter leading-none font-medium">Who has our back.</h1>
        <p className="text-neutral-400 mt-3 max-w-xl">Film commissions, guilds, education programs, and nonprofits supporting Southern Utah production.</p>
      </div>
      {loading ? (
        <div className="text-sm text-neutral-500">Loading partners…</div>
      ) : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 ff-stagger" data-testid="orgs-grid">
          {orgs.map((o, i) => (
            <div key={o.id || i} className="ff-card p-6" data-testid={`org-card-${i}`}>
              <div className="w-11 h-11 rounded-lg bg-white/5 border border-white/10 flex items-center justify-center mb-4">
                <Building2 className="w-4 h-4 ff-accent-text" />
              </div>
              <div className="text-xs uppercase tracking-widest text-neutral-500">{o.type || "Partner"}</div>
              <div className="font-display text-lg tracking-tight mt-1">{o.name}</div>
              <div className="text-xs text-neutral-500 mt-1">{o.region || o.location || "Southern Utah"}</div>
              {o.website && (
                <a href={o.website} target="_blank" rel="noreferrer" className="mt-4 inline-flex items-center gap-1 text-xs ff-accent-text hover:underline">
                  Visit site <ExternalLink className="w-3 h-3" />
                </a>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
